import { activityItemService } from "@/services/activityItemService";
import { ProductItemsSection } from "@/components/common";
import type { ServiceCategory } from "@/types";

interface ServiceItemsSectionProps {
  activityId: string;
  activityCommissionRate: number;
  serviceCategories: ServiceCategory[];
}

export function ServiceItemsSection({
  activityId,
  activityCommissionRate,
  serviceCategories,
}: ServiceItemsSectionProps) {
  return (
    <ProductItemsSection
      activityId={activityId}
      activityCommissionRate={activityCommissionRate}
      itemType="service"
      entityType="activity_items"
      queryKey="serviceItems"
      getAllFn={(id) => activityItemService.listService(id)}
      createFn={activityItemService.create}
      updateFn={activityItemService.update}
      deleteFn={activityItemService.delete}
      serviceCategories={serviceCategories}
    />
  );
}
